<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {ContentColumnsSlice} from '@prismicio-types';
    import ContentColumnsClassic from './variations/ContentColumnsClassic.vue';
    import ContentColumnsDefault from './variations/ContentColumnsDefault.vue';
    import ContentColumnsGrid from './variations/ContentColumnsGrid.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<ContentColumnsSlice>());

    const variationComponents = {
        default: ContentColumnsDefault,
        contentColumnsClassic: ContentColumnsClassic,
        contentColumnsGrid: ContentColumnsGrid,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
